export enum BusinessEntityType {
  Provider,
  Client,
  Manufacturer,
  Consignee,
  Brand,
  InternalCompany,
}

export interface BusinessSearch {
  name?: string;
  code?: string;
  businessTypes: BusinessEntityType[];
}

export interface ClientDetails {
  overagePercentage?: number;
}

export interface Business {
  addresses?: Address[];
  aliases?: string[];
  businessTypes: number[];
  code?: string;
  createdBy?: string;
  createdDate?: string;
  id?: string;
  leadAssociateUserName?: string;
  lotNumbers?: string[];
  modifiedBy?: string;
  modifiedDate?: string;
  name: string;
  taxIndicatorCode?: string;
  fieldToDisplay?: string; // Optional field for displaying in typeahead
  clientDetails?: ClientDetails;
  representatives?: Representative[];
}

export interface Representative {
  id?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  phoneExtension?: string;
  email?: string;
  role?: string;
}

export interface Address {
  id: string;
  code: number;
  country: string;
  city: string;
  address1: string;
  address2: string;
  stateOrProvince: string;
  zipCode: string;
  addressTypes: number[];
  fieldToDisplay?: string;
  displayName?: string;
}
export enum AddressType {
  Billing,
  Shipping,
  HeadOffice,
  Branch,
  Warehouse,
  Other,
  Main,
}

export interface BusinessSearchCommand {
  name?: string;
  code?: string;
  businessTypes: BusinessEntityType[];
}
